import React, { useCallback } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { DefaultTheme } from '../../Themes';
import Label from '../Label';
const StyledContainer = styled.div `
  display: inline-flex;
  align-items: center;
`;
const StyledInputWrapper = styled.div `
  position: relative;
  width: 1.666666667rem;
  height: 1.666666667rem;

  ${({ hasLabel }) => hasLabel && css `
    margin-right: 0.416666667rem;
  `};
`;
const inputWrapperChildStyles = css `
  position: absolute;
  width: 100%;
  height: 100%;
`;
const StyledInputMask = styled.span `
  ${inputWrapperChildStyles};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${({ color, theme }) => color || theme.ThemeColors.DARK_BORDER.hex};
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 0;

  ${({ isDisabled }) => isDisabled && css `
    opacity: 0.5;
  `};

  &::after {
    content: '';
    display: inline-block;
    width: 0.833333333rem;
    height: 0.833333333rem;
    border-radius: 50%;
  }
`;
const StyledInputRadio = styled.input `
  ${inputWrapperChildStyles};
  margin: 0;
  opacity: 0;
  z-index: 1;
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};

  &:checked + ${StyledInputMask} {
    ${({ colorWhenChecked, theme }) => css `
      & {
        border-color: ${colorWhenChecked || theme.ThemeColors.PRIMARY.hex};
      }

      &::after {
        background-color: ${colorWhenChecked || theme.ThemeColors.PRIMARY.hex};
      }
    `};
  }
`;
const RadioButton = ({ id, isDisabled, isSelected, label, name, onChange = () => { }, value, color, colorWhenChecked, theme = DefaultTheme, }) => {
    const hasLabel = !!(label && id);
    const handleChange = useCallback((event) => {
        if (!isDisabled) {
            onChange(event);
        }
    }, [isDisabled, onChange]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledContainer, null,
            React.createElement(StyledInputWrapper, { hasLabel: hasLabel },
                React.createElement(StyledInputRadio, { type: 'radio', checked: isSelected, colorWhenChecked: colorWhenChecked, disabled: isDisabled, id: id, name: name, onChange: handleChange, value: value }),
                React.createElement(StyledInputMask, { color: color, isDisabled: isDisabled })),
            hasLabel && React.createElement(Label, { labelFor: id, text: label }))));
};
export default RadioButton;
